module.exports = require("./shi.js");